// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const Staff: React.FC<SvgProps> = (props) => (
  <Svg {...props} width="23.75" height="19" viewBox="0 0 23.75 19">
    <path
      id="パス_72"
      data-name="パス 72"
      d="M5.344-10.687a2.968,2.968,0,0,1-2.969-2.969,2.968,2.968,0,0,1,2.969-2.969,2.968,2.968,0,0,1,2.969,2.969A2.968,2.968,0,0,1,5.344-10.687Zm13.656,0a2.968,2.968,0,0,1-2.969-2.969A2.968,2.968,0,0,1,19-16.625a2.968,2.968,0,0,1,2.969,2.969A2.968,2.968,0,0,1,19-10.687ZM0-5.54A3.961,3.961,0,0,1,3.96-9.5H5.544A3.981,3.981,0,0,1,7.2-9.14a4.67,4.67,0,0,0-.071.828A4.752,4.752,0,0,0,8.736-4.75H.79A.793.793,0,0,1,0-5.54Zm15.04.79h-.026a4.739,4.739,0,0,0,1.607-3.562,5.082,5.082,0,0,0-.071-.828,3.923,3.923,0,0,1,1.655-.36H19.79a3.961,3.961,0,0,1,3.96,3.96.791.791,0,0,1-.79.79Zm.4-3.562A3.563,3.563,0,0,1,11.875-4.75,3.563,3.563,0,0,1,8.313-8.312a3.563,3.563,0,0,1,3.563-3.562A3.563,3.563,0,0,1,15.438-8.312ZM4.75,1.384A4.948,4.948,0,0,1,9.7-3.562h4.357A4.948,4.948,0,0,1,19,1.384a.991.991,0,0,1-.991.991H5.741a.991.991,0,0,1-.991-.991Z"
      transform="translate(0 16.625)"
    />
  </Svg>
);

Staff.displayName = 'Staff';

export default Staff;
